(function () {
  if (window.__pdpFaqJs) return;
  window.__pdpFaqJs = true;

  var ANIM_MS = 300;

  function onceTransitionEnd(el, propName, fn, ms) {
    if (!el) {
      fn();
      return;
    }
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', handler);
      fn();
    };
    var handler = function (e) {
      if (e.target !== el) return;
      if (propName && e.propertyName !== propName) return;
      finish();
    };
    el.addEventListener('transitionend', handler);
    setTimeout(finish, (ms || ANIM_MS) + 80);
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-pdp-faq-ready') === 'true') return;

    var list = root.querySelector('[data-pdp-faq-list]');
    if (!list) return;

    root.setAttribute('data-pdp-faq-ready', 'true');

    var items = Array.prototype.slice.call(list.querySelectorAll('details.pdp-faq__item'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.pdp-faq__tab'));
    var moreLabel = root.getAttribute('data-more-label') || 'Show more';
    var lessLabel = root.getAttribute('data-less-label') || 'Show less';
    var keepCursor = root.getAttribute('data-show-more-scroll') === 'true';
    var hasTabs = tabs.length > 1;
    var activeTab = root.getAttribute('data-active-tab') || '1';
    var expanded = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SWITCH_MS = 400;
    var switchTimer = null;

    function closeItem(item, instant) {
      var ans = item.querySelector('.pdp-faq__answer');
      if (!ans) {
        item.open = false;
        return;
      }
      if (instant) {
        item.open = false;
        ans.style.maxHeight = '';
        return;
      }
      ans.style.maxHeight = ans.scrollHeight + 'px';
      ans.offsetHeight;
      requestAnimationFrame(function () {
        ans.style.maxHeight = '0px';
      });
      onceTransitionEnd(ans, 'max-height', function () {
        item.open = false;
        ans.style.maxHeight = '';
      });
    }

    function openItem(item) {
      var ans = item.querySelector('.pdp-faq__answer');
      if (!ans) {
        item.open = true;
        return;
      }
      item.open = true;
      var target = ans.scrollHeight;
      ans.style.maxHeight = '0px';
      ans.offsetHeight;
      requestAnimationFrame(function () {
        ans.style.maxHeight = target + 'px';
      });
      onceTransitionEnd(ans, 'max-height', function () {
        ans.style.maxHeight = '';
      });
    }

    function visibleItems() {
      if (!hasTabs) return items;
      return items.filter(function (item) {
        return item.getAttribute('data-tab') === activeTab;
      });
    }

    function hiddenClass() {
      return window.matchMedia('(min-width: 990px)').matches
        ? 'pdp-faq__item--hidden-desktop'
        : 'pdp-faq__item--hidden-mobile';
    }

    function getHiddenItemsHeight() {
      var cls = hiddenClass();
      var hiddenItems = visibleItems().filter(function (item) {
        return item.classList.contains(cls);
      });
      var gapSize = window.matchMedia('(min-width: 990px)').matches ? 14 : 12;
      var total = 0;
      hiddenItems.forEach(function (it) {
        total += it.scrollHeight + gapSize;
      });
      return total;
    }

    function syncShowMore() {
      var btn = root.querySelector('[data-pdp-faq-show-more]');
      if (!btn) return;
      var cls = hiddenClass();
      var hasHidden = visibleItems().some(function (item) {
        return item.classList.contains(cls);
      });
      btn.hidden = !hasHidden;
      var text = btn.querySelector('[data-pdp-faq-show-more-text]');
      if (text) text.textContent = expanded ? lessLabel : moreLabel;
      btn.setAttribute('aria-expanded', String(expanded));
    }

    function isCollapsedByShowMore(item) {
      var cls = hiddenClass();
      return item.classList.contains(cls) && !list.classList.contains('pdp-faq__list--expanded');
    }

    function resetItemSurface(item) {
      item.style.maxHeight = '';
      item.style.opacity = '';
      item.style.marginTop = '';
      item.style.transitionDelay = '';
    }

    function setActiveTab(nextTab) {
      if (!nextTab || !hasTabs) return;
      nextTab = String(nextTab);
      if (nextTab === activeTab) return;

      var fromH = list.offsetHeight;
      if (switchTimer) {
        clearTimeout(switchTimer);
        switchTimer = null;
      }

      activeTab = nextTab;
      root.setAttribute('data-active-tab', activeTab);

      items.forEach(function (item) {
        closeItem(item, true);
        resetItemSurface(item);
      });

      expanded = false;
      list.classList.remove('pdp-faq__list--expanded');

      var incoming = [];
      items.forEach(function (item) {
        var onTab = item.getAttribute('data-tab') === activeTab;
        item.setAttribute('aria-hidden', onTab ? 'false' : 'true');
        item.classList.toggle('is-off-tab', !onTab);
        if (onTab && !isCollapsedByShowMore(item)) incoming.push(item);
      });

      incoming.forEach(function (item) {
        if (item.hasAttribute('data-open-default')) item.open = true;
      });

      tabs.forEach(function (tab) {
        var selected = tab.getAttribute('data-tab') === activeTab;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && tab.getAttribute('data-tab-color')) {
          root.style.setProperty('--pdp-faq-tab-color', tab.getAttribute('data-tab-color'));
        }
      });

      syncShowMore();

      if (reduceMotion) {
        list.style.height = '';
        list.classList.remove('is-switching');
        return;
      }

      incoming.forEach(function (item, i) {
        item.style.opacity = '0';
        item.style.transitionDelay = i * 30 + 'ms';
      });

      list.classList.add('is-switching');
      list.style.transition = 'none';
      list.style.height = fromH + 'px';
      list.style.height = 'auto';
      var toH = list.offsetHeight;
      list.style.height = fromH + 'px';
      list.offsetHeight;
      list.style.transition = '';

      requestAnimationFrame(function () {
        incoming.forEach(function (item) {
          item.style.opacity = '1';
        });
        list.style.height = toH + 'px';
      });

      switchTimer = setTimeout(function () {
        incoming.forEach(function (item) {
          resetItemSurface(item);
        });
        list.style.height = '';
        list.style.transition = '';
        list.classList.remove('is-switching');
        switchTimer = null;
      }, SWITCH_MS + 80);
    }

    items.forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.open) {
          closeItem(item);
        } else {
          visibleItems().forEach(function (other) {
            if (other !== item && other.open) closeItem(other);
          });
          openItem(item);
        }
      });
    });

    if (hasTabs) {
      var first = tabs.filter(function (tab) {
        return tab.classList.contains('is-active');
      })[0] || tabs[0];
      if (first && first.getAttribute('data-tab-color')) {
        root.style.setProperty('--pdp-faq-tab-color', first.getAttribute('data-tab-color'));
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          setActiveTab(tab.getAttribute('data-tab'));
        });
      });

      var switcher = root.querySelector('.pdp-faq__switcher');
      if (switcher) {
        switcher.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(document.activeElement);
          if (i < 0) return;
          var next = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next < 0) return;
          e.preventDefault();
          tabs[next].focus();
          setActiveTab(tabs[next].getAttribute('data-tab'));
        });
      }

    }

    var btn = root.querySelector('[data-pdp-faq-show-more]');
    if (btn) {
      var text = btn.querySelector('[data-pdp-faq-show-more-text]');
      btn.addEventListener('click', function () {
        var willExpand = !expanded;
        var shift = keepCursor && willExpand ? getHiddenItemsHeight() : 0;

        expanded = willExpand;
        list.classList.toggle('pdp-faq__list--expanded', willExpand);
        if (text) text.textContent = willExpand ? lessLabel : moreLabel;
        btn.setAttribute('aria-expanded', String(willExpand));

        if (keepCursor && shift !== 0) {
          window.scrollBy({ top: willExpand ? shift : -shift, behavior: 'smooth' });
        }

        syncShowMore();
      });

      syncShowMore();
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-pdp-faq]');
    for (var i = 0; i < nodes.length; i++) initRoot(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pdp-faq]');
    if (!root) return;
    root.removeAttribute('data-pdp-faq-ready');
    initRoot(root);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-pdp-faq]');
    if (!root) return;
    var tabBtn = e.target.closest('.pdp-faq__tab');
    var item = e.target.closest('.pdp-faq__item');
    var tab = tabBtn
      ? tabBtn.getAttribute('data-tab')
      : item && item.getAttribute('data-tab');
    if (!tab) return;
    var match = root.querySelector('.pdp-faq__tab[data-tab="' + tab + '"]');
    if (match) match.click();
  });
})();
